import React from 'react';
import { FadeIn } from '../ui/FadeIn';
export function PhasesSection() {
  return <section className="py-20 px-6 bg-forest text-white" data-id="element-116">
      <div className="max-w-4xl mx-auto" data-id="element-117">
        <FadeIn data-id="element-118">
          <h2 className="text-4xl md:text-5xl font-bold text-center mb-16 text-cream" data-id="element-119">
            Cómo funciona
          </h2>

          <div className="space-y-8 relative before:absolute before:inset-0 before:ml-5 before:-translate-x-px md:before:mx-auto md:before:translate-x-0 before:h-full before:w-1 before:bg-gradient-to-b before:from-transparent before:via-amber/50 before:to-transparent" data-id="element-120">
            <div className="relative flex items-center justify-between md:justify-normal md:odd:flex-row-reverse group is-active" data-id="element-121">
              <div className="flex items-center justify-center w-10 h-10 rounded-full border-4 border-forest bg-amber shrink-0 md:order-1 md:group-odd:-translate-x-1/2 md:group-even:translate-x-1/2 shadow-xl z-10" data-id="element-122">
                <span className="font-bold text-forest" data-id="element-123">1</span>
              </div>
              <div className="w-[calc(100%-4rem)] md:w-[calc(50%-2.5rem)] bg-white/10 backdrop-blur-md p-6 md:p-8 rounded-2xl border border-white/20 shadow-xl" data-id="element-124">
                <h3 className="text-amber font-bold text-xl mb-2" data-id="element-125">
                  Fase 1 (Días 1-3)
                </h3>
                <p className="text-lg text-cream/90" data-id="element-126">
                  Detenemos el daño ácido y desinflamamos.
                </p>
              </div>
            </div>

            <div className="relative flex items-center justify-between md:justify-normal md:odd:flex-row-reverse group is-active" data-id="element-127">
              <div className="flex items-center justify-center w-10 h-10 rounded-full border-4 border-forest bg-amber shrink-0 md:order-1 md:group-odd:-translate-x-1/2 md:group-even:translate-x-1/2 shadow-xl z-10" data-id="element-128">
                <span className="font-bold text-forest" data-id="element-129">2</span>
              </div>
              <div className="w-[calc(100%-4rem)] md:w-[calc(50%-2.5rem)] bg-white/10 backdrop-blur-md p-6 md:p-8 rounded-2xl border border-white/20 shadow-xl" data-id="element-130">
                <h3 className="text-amber font-bold text-xl mb-2" data-id="element-131">
                  Fase 2 (Días 4-10)
                </h3>
                <p className="text-lg text-cream/90" data-id="element-132">
                  Ejecutamos el lavado profundo con el recetario de 50 platos.
                </p>
              </div>
            </div>

            <div className="relative flex items-center justify-between md:justify-normal md:odd:flex-row-reverse group is-active" data-id="element-133">
              <div className="flex items-center justify-center w-10 h-10 rounded-full border-4 border-forest bg-amber shrink-0 md:order-1 md:group-odd:-translate-x-1/2 md:group-even:translate-x-1/2 shadow-xl z-10" data-id="element-134">
                <span className="font-bold text-forest" data-id="element-135">3</span>
              </div>
              <div className="w-[calc(100%-4rem)] md:w-[calc(50%-2.5rem)] bg-white/10 backdrop-blur-md p-6 md:p-8 rounded-2xl border border-white/20 shadow-xl" data-id="element-136">
                <h3 className="text-amber font-bold text-xl mb-2" data-id="element-137">
                  Fase 3 (Días 11-14)
                </h3>
                <p className="text-lg text-cream/90" data-id="element-138">
                  Blindamos tus resultados y preparamos tu nueva vida.
                </p>
              </div>
            </div>
          </div>
        </FadeIn>
      </div>
    </section>;
}